export type ListResponse<T> = {
  list?: T[];
  items?: T[];
  data?: T[];
  members?: T[];
  total?: number;
  count?: number;
};

export type DetailResponse<T> = {
  data?: T;
  result?: T;
  payload?: T;
};

export const extractList = <T>(response?: ListResponse<T> | null): T[] => {
  return (
    response?.list ??
    response?.items ??
    response?.data ??
    response?.members ??
    []
  );
};

export const extractTotal = <T>(response?: ListResponse<T> | null): number => {
  return response?.total ?? response?.count ?? extractList(response).length;
};

export const extractDetail = <T>(
  response?: DetailResponse<T> | T | null,
): T | undefined => {
  if (!response) {
    return undefined;
  }
  if (typeof response === 'object' && !Array.isArray(response)) {
    const wrapped = response as DetailResponse<T>;
    return wrapped.data ?? wrapped.result ?? wrapped.payload ?? (response as T);
  }
  return response as T;
};
